import i18n from "../../../../../config/dictionary/i18n";


export function formatAmount(number: number, multiplier: number = 1) {
    if (number === null || number === undefined || Number.isNaN(number)) {
        return "---";
    }
    return new Intl.NumberFormat().format(number * multiplier);
}
export const getQuarterly = (): string[] => {
    let quarters = [];
    let updateQuarter = 0;
    let quarterMonths = "";
    for (let i = 1; i < 5; i++) {
        for (let j = updateQuarter; j < (updateQuarter + 3); j++) {
            quarterMonths += (
                new Date(Date.UTC(0, j, 1)).toLocaleDateString(i18n.language,
                    {month: 'long'}).toUpperCase() + " - ");
        }
        quarters.push("Q" + i + ": " + quarterMonths.replace(/- $/, " "));
        quarterMonths = "";
        updateQuarter += 3;
    }
    return quarters;
}


export const getQuarterlyByKey = (key: string): string => {
    let quarter = "";
    getQuarterly().map((it: string, index) => {
        if (key === (it.slice(0, 2))) {
            quarter = it.charAt(0).toUpperCase() + it.slice(1);
        }
    });
    return quarter;
}

export const onDownloadPrintout = (response: any, year: any, quartertly: any) => {
    const href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response.result.file}`;
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', 'Intermediaries Report Log '
        +year + " " + quartertly+ '.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
}

export function downloadPDF(pdf: string, fileName: any) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
}

